/**
 * @description Modal 列表 (enum)
 */
export enum ModalNamesEnum {
  /** 閒置 */
  IdleModal = 'idleModal',
  /** 會員中心-會員登入 */
  MemberLoginModal = 'memberLoginModal',
  /** 會員中心-網服註冊 */
  MemberRegisterNSModal = 'memberRegisterNSModal',
  /** 主首頁-最新消息 */
  HomeMainNewsContentModal = 'homeMainNewsContentModal',
  /** 旅平險首頁-申請保險金應附文件 */
  HomeTravelInsClaimDocumentsModal = 'homeTravelInsClaimDocumentsModal',
  /** 會員中心-查看登入紀錄 */
  MemberProfileLoginRecordModal = 'memberProfileLoginRecordModal'
};
